import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getGruposMonitoramento } from "./services";
import { TCentral } from "./types";

interface IInitialState {
  status: "error" | "success" | "loading" | "",
  grupoMonitoramentoSelected: any,
  data: Array<TCentral>,
}

const initialState = {} as IInitialState;

export const actionGetGrupoMonitoramento: any = createAsyncThunk<any, string>(
  "ACTION_GET_GRUPOS_MONITORAMENTO",
  async (_: any) => {
    return getGruposMonitoramento();
  }
);

const sliceGetGrupoMonitoramento = createSlice({
  name: "GET_GRUPOS_MONITORAMENTO",
  initialState,
  reducers: {
    actionSelectGrupoMonitoramento: (state, { payload }) => {
      state.grupoMonitoramentoSelected = state.data.find(
        ({ id }) => id === Number(payload)
      );
    },
    actionResetGrupoMonitoramento: (state) => {
      state.status = ""
      state.grupoMonitoramentoSelected = null;
      state.data = []
    },
  },
  extraReducers: {
    [actionGetGrupoMonitoramento.pending]: (state) => {
      state.status = "loading";
    },
    [actionGetGrupoMonitoramento.fulfilled]: (state, { payload }) => {
      state.status = "success";
      state.data = payload;
    },
    [actionGetGrupoMonitoramento.rejected]: (state) => {
      state.status = "error";
    },
  },
});

export default sliceGetGrupoMonitoramento.reducer;
export const { actionSelectGrupoMonitoramento, actionResetGrupoMonitoramento } = sliceGetGrupoMonitoramento.actions;
